import { ConditionRegistryItem } from '../../ConditionRegistryItem';
import { ConditionRegistryCategory } from '../../ConditionRegistryCategory';
export class ConditionRegistryString extends ConditionRegistryCategory {
    label = 'String';
    constructor(parent) {
        super(parent);
        super.init();
    }
    endsWith = () => new ConditionRegistryItem({
        eval: ({ rightChildEvaluator, condition }) => !!rightChildEvaluator &&
            typeof rightChildEvaluator.conditionValue === 'string' &&
            rightChildEvaluator.conditionValue.endsWith(condition.local.valueOf.stringValue)
        /* params: { core: ['stringValue'] } */
    });
    contains = () => new ConditionRegistryItem({
        eval: ({ rightChildEvaluator, condition }) => !!rightChildEvaluator &&
            typeof rightChildEvaluator.conditionValue === 'string' &&
            rightChildEvaluator.conditionValue.includes(condition.local.valueOf.stringValue)
        /*  params: { core: ['stringValue'] } */
    });
}
